import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import styled from '@emotion/styled';
import { ThemeProvider } from '@emotion/react';
import theme from 'shared/styles/theme';
import { ApolloProvider } from '@apollo/client';
import client from 'apollo/client';
import { ROUTES } from 'shared/constants';
import LandingPage from 'Pages/Landing/Landing.page';
import HomePage from 'Pages/Home/Home.page';
import ScrollToTop from 'shared/utils/ScrollToTop';

function App() {
  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <Router>
          <AppContainer>
            <ScrollToTop />
            <Switch>
              <Route exact path={ROUTES.LANDING}>
                <LandingPage />
              </Route>
              <Route exact path={ROUTES.HOME}>
                <HomePage />
              </Route>
            </Switch>
          </AppContainer>
        </Router>
      </ThemeProvider>
    </ApolloProvider>
  );
}
const AppContainer = styled.div({
  width: '100vw',
  minHeight: '100vh',
});

export default App;
